"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef, useState } from "react";
import { ExternalForm, ExternalFormProps } from "../ExternalForm/ExternalForm";
import { Icon, IconType } from "@/components/formatters/MXPIcon";
import { TerraLink } from "../../component/TerraLink/TerraLink";
import { EmailButton } from "../../component/EmailButton/EmailButton";
import { getActionBlockButtonClasses, type ActionBlockPresetTheme } from "./actionBlockButtonClasses";
export interface ActionBlockProps {
  header?: string;
  headerIcon?: IconType;
  buttons?: [TerraLink] | undefined;
  presetTheme?: ActionBlockPresetTheme;
  displayType: "email" | "buttons";
  formPlaceholder?: string;
  formData?: ExternalFormProps;
}
const EMAIL_OVERRIDES = ["[&_.t2-email-button]:w-20 [&_.t2-email-button]:h-20 [&_.t2-email-button]:-top-5", "max-sm:[&_.t2-email-button]:flex max-sm:[&_.t2-email-button]:items-center max-sm:[&_.t2-email-button]:justify-center", "[&_.t2-email-button__wrap]:w-full [&_.t2-email-button__wrap]:items-center", "[&_.t2-email-button__field]:pl-[30px] [&_.t2-email-button__field]:max-w-[310px] [&_.t2-email-button__field]:pr-[65px]", "[&_.t2-email-button__submit-icon]:ml-[18px] max-sm:[&_.t2-email-button__submit-icon]:ml-0", "[&_.t2-email-button__search-icon]:absolute"].join(" ");
export const ActionBlock = t0 => {
  const $ = _c(38);
  const {
    header,
    headerIcon,
    buttons,
    presetTheme,
    displayType,
    formPlaceholder,
    formData
  } = t0;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [emailFieldAutoPop, setEmailFieldAutoPop] = useState("");
  const emailFieldRef = useRef(null);
  const dialogRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== modalIsOpen) {
    t1 = () => {
      const dialog = dialogRef.current;
      if (!dialog) {
        return;
      }
      if (modalIsOpen && !dialog.open) {
        dialog.showModal();
      } else {
        if (!modalIsOpen && dialog.open) {
          dialog.close();
        }
      }
    };
    t2 = [modalIsOpen];
    $[0] = modalIsOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function openModal() {
      const emailFieldValue = emailFieldRef?.current && emailFieldRef?.current?.value;
      emailFieldValue && setEmailFieldAutoPop(emailFieldValue);
      setModalIsOpen(true);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const openModal = t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function closeModal() {
      setModalIsOpen(false);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const closeModal = t4;
  const colorSetting = presetTheme == "t2-action-theme-two" ? "t2-color-setting--dark" : "t2-color-setting--light";
  const isEmail = displayType === "email";
  const emailBgOverride = presetTheme === "t2-action-theme-one" ? "[&_.t2-email-button]:bg-gray-m10" : "";
  const cardClasses = `m-[10px] rounded-lg py-5 px-4 min-sm:px-20 min-lg:px-[115px] ${presetTheme} ${colorSetting} ${isEmail ? EMAIL_OVERRIDES : ""} ${emailBgOverride}`;
  let componentStyles;
  if (presetTheme == "t2-action-theme-two") {}
  let t10;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[5] !== buttons || $[6] !== cardClasses || $[7] !== emailFieldAutoPop || $[8] !== formData || $[9] !== formPlaceholder || $[10] !== header || $[11] !== headerIcon || $[12] !== isEmail || $[13] !== presetTheme) {
    const renderButtonsBlock = () => <div className={`flex items-center justify-center ${isEmail ? "" : "gap-x-2.5 min-lg:gap-x-[14px] max-sm:flex-col max-sm:gap-y-4 max-sm:w-full"}`}>{isEmail ? <EmailButton {...buttons?.[0]} emailButtonClickHandler={openModal} label={formPlaceholder || buttons && buttons[0]?.label} emailFieldRef={emailFieldRef} /> : buttons && buttons?.map((button, index) => <TerraLink key={`${button?.id}-${index}`} {...button} disableStyles={true} className={getActionBlockButtonClasses(presetTheme, button.primary === true)} />)}</div>;
    t9 = cardClasses;
    t10 = componentStyles;
    t5 = `flex min-h-[88px] gap-x-[15px] max-sm:flex-wrap max-sm:flex-col ${isEmail ? "justify-between" : "justify-around"}`;
    if ($[20] !== header || $[21] !== headerIcon) {
      t6 = header && <h2 className="text-gray-m9 text-xl font-bold leading-relaxed text-center justify-center m-0 flex items-start flex-col max-sm:items-center max-sm:mb-6 t2-dark:text-white [&_.t2-icon]:mb-4">{headerIcon && <Icon className="hidden sm:block mr-[10px] fill-gray-m9 t2-dark:fill-white" type={headerIcon} size={24} />}{header}</h2>;
      $[20] = header;
      $[21] = headerIcon;
      $[22] = t6;
    } else {
      t6 = $[22];
    }
    let t11;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = event => {
        if (event.target === dialogRef.current) {
          closeModal();
        }
      };
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] !== emailFieldAutoPop || $[25] !== formData) {
      t12 = formData && <ExternalForm {...formData} setModalIsOpen={setModalIsOpen} emailFieldAutoPop={emailFieldAutoPop} />;
      $[24] = emailFieldAutoPop;
      $[25] = formData;
      $[26] = t12;
    } else {
      t12 = $[26];
    }
    if ($[27] !== t12) {
      t7 = <dialog ref={dialogRef} aria-label="Action Block Modal" onClose={closeModal} onClick={t11} className="m-0 w-screen h-screen max-w-none max-h-none border-0 p-0 bg-black/55 overflow-y-auto z-[99]">{t12}</dialog>;
      $[27] = t12;
      $[28] = t7;
    } else {
      t7 = $[28];
    }
    t8 = renderButtonsBlock();
    $[5] = buttons;
    $[6] = cardClasses;
    $[7] = emailFieldAutoPop;
    $[8] = formData;
    $[9] = formPlaceholder;
    $[10] = header;
    $[11] = headerIcon;
    $[12] = isEmail;
    $[13] = presetTheme;
    $[14] = t10;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t10 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t11;
  if ($[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8) {
    t11 = <div className={t5}>{t6}{t7}{t8}</div>;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t9) {
    t12 = <div className={t9} style={t10}>{t11}</div>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t9;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  return t12;
};